module.exports = __webpack_public_path__ + "static/media/7.479ff3af.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/7.png
// module id = 1435
// module chunks = 0